import {
  getGroupList,
  getTicketTypeList,
  getAdvanceCouponTypeList,
  getRuleDetail,
} from "@/helpers/service/api/ruleTemplate.js";
import { getVersion, getOtherVersion } from "@/helpers/service/api/common.js";
import { getCouponTypeListForSelect } from "@/helpers/service/api/coupon";

export const createFormObj = () => {
  return {
    name: "",
    ticketRule: {
      boxOfficeType: "boxOffice",
      customizeMsg: [
        {
          deviceType: "",
          message: "",
        }
      ],
      generalTicket: {
        default: true,
        name: "",
        price: 0,
        sort: "0",
        groupId: "",
        ticketTypeId: "",
        availableMembers: [],
        salesNum: "1",
        displayDate: {
          all: true,
          week: [],
          month: [],
        },
        unDisplayDate: {
          // all: false,
          all: true,
          week: [],
          month: [],
        },
        unDisplayDevice: [],
        couponIds: [],
        seatsStatus: [],
        warningMsg: [],
      },

      otherTicket: [],

      commonCoupon: false,
      otherCommonCoupon: true,

      unAdvanceCouponTypeIds: [],

      versionPriceRule: [],

      seatPriceRule: [],

      posStartSale: {
        salesDateType: "day",
        hourDate: "00:00",
      },

      posEndSale: {
        salesDateType: "day",
        hourDate: "00:00",
      },

      seatMaxPos: 10,
      seatMaxSelfCashier: 10,
      seatMaxWeb: 10,
      webPreSaleSeatMax: 10,

      webStartSale: {
        salesDateType: "day",
        hourDate: "00:00",
      },

      webEndSale: {
        salesDateType: "day",
        hourDate: "00:00",
      },
      posPreSaleRule: [
        {
          membershipRankId: "",
          timeAmount: null,
          timeUnit: 'minute',
        }
      ],
      webPreSaleRule: [
        {
          membershipRankId: "",
          timeAmount: null,
          timeUnit: 'minute',
        }
      ],
      scPreSaleRule: [
        {
          membershipRankId: "",
          timeAmount: null,
          timeUnit: 'minute',
        }
      ],
      scStartSale: {
        salesDateType: "day",
        hourDate: "00:00",
      },
      
      scEndSale: {
        salesDateType: "day",
        hourDate: "00:00",
      },

      taxRate: 0.10,

      standingmax: 0,

      advanced: {
        salesDateType: "now",
      }
    },
  };
};

export const getGroup = cinemaId => {
  return new Promise((resolve, reject) => {
    getGroupList({
      page: 0,
      pageSize: 9999,
      type: "ticketType",
      cinemaId: cinemaId,
    }, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getTicketType = cinemaId => {
  return new Promise((resolve, reject) => {
    getTicketTypeList({
      page: 0,
      pageSize: 9999,
      cinemaId: cinemaId,
    }, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getCouponType = (cinemaId, type) => {
  return new Promise((resolve, reject) => {
    getCouponTypeListForSelect({
      page: 0,
      pageSize: 9999,
      cinemaId: cinemaId,
      type: type,
      field: ["id", "name"]
    }, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getAdvanceCouponType = () => {
  return new Promise((resolve, reject) => {
    getAdvanceCouponTypeList({
      page: 0,
      pageSize: 9999,
    }, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getVersionList = cinemaId => {
  return new Promise((resolve, reject) => {
    getVersion({
      page: 0,
      pageSize: 9999,
      cinemaId: cinemaId,
    }, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getOtherVersionList = cinemaId => {
  return new Promise((resolve, reject) => {
    getOtherVersion({
      page: 0,
      pageSize: 9999,
      cinemaId: cinemaId,
    }, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });
};

export const getRuleTemplateDetail = (id = "") => {
  const params = {
    id: id
  };

  if (id == "") {
    return new Promise(resolve => {
      resolve({});
    });
  }
  return new Promise((resolve, reject) => {
    getRuleDetail(params, false, false).then(res => {
      if (res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    }).catch(err => {
      reject(err);
    });
  });

};
